<template>
	<MasterAwbupcoming-component>
		<div class="animated fadeIn">
		 <b-row>
            <b-col sm="12">
              <b-card>
            	<div slot="header">
                 <strong>MasterAwb Upcoming</strong>
			    </div>
			    <b-col sm="12" class="text-right">
	               <!--  <b-button v-if="this.totalRows >0"  variant="primary" size="md" @click="downloadCSV">Download </b-button>  -->
	               <p > <b>Total Records :<span style="color:red;">{{totalRows}}</span></b> </p>
                </b-col> 
			    <b-table responsive show-empty  :busy="isBusy" :items="upcomingitem" :fields="upcomingfields"  :current-page="currentPage" :per-page="perPage" :filter="filter"   :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection" @filtered="onFiltered" :bordered="bordered" >

                <div slot="table-busy" class="text-center text-danger my-2">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong>Loading...</strong>
                </div>
           		<template slot="shipment_count" slot-scope="row">
           			 <button  title="View Shipment" @click="viewShipment(row.item.master_awb)" style="background-color:white !important;" class="btn btn-link"  >
                  <span style="color:#1b8eb7"> {{row.item.shipment_count}}</span>
               
               </button>
           		</template>

               </b-table>
               <b-col md="12" class="my-1 " v-if="totalRows>10">
	            <b-pagination
	                v-model="currentPage"
	                :total-rows="totalRows"
	                :per-page="perPage"
	                class="my-0"
	              ></b-pagination>
          </b-col> 
            <b-modal size="lg" title="MasterAwb Shipment Log" v-model="shipmentModal" hide-footer>
          	<b-row>
              <b-col sm="12" class="text-right">
              
               <p > <b>Total Records :<span style="color:red;">{{total_row_shipment }}</span></b> </p>
              </b-col> 
              <b-col sm="12">
	            <b-table show-empty stacked="md"  :items="shipmentawblist" :busy="isBusyshipment"  :fields="fields1" :current-page="shipcurrentPage" :per-page="shipperPage" :filter="filter"   :sort-by.sync="sortBy"  :sort-desc.sync="sortDesc"   :sort-direction="sortDirection"      :bordered="bordered" >
	            	<div slot="table-busy" class="text-center text-danger my-2">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong>Loading...</strong>
                </div>
	            </b-table>
	         </b-col>
	         <b-col md="12" class="my-1 " v-if="total_row_shipment>10">
            <b-pagination
                v-model="shipcurrentPage"
                :total-rows="total_row_shipment"
                :per-page="shipperPage"
                class="my-0"
              ></b-pagination>
          </b-col> 
           </b-row>
           </b-modal>
              </b-card>
            </b-col>
         </b-row>
		</div>
	</MasterAwbupcoming-component>
</template>
<script>
import CONSTANTS from "@/utils/constants";
import Utils from "@/utils";
import Vue from 'vue';
export default {
	data(){
		return{
			outlined:true,
	        bordered: true,
	        sortDesc: false,
	        allowCustomValue : true,
	        sortDirection: 'desc',
	        filter: null,
	        sortBy: null,
			isBusy:false,
			pageOptions: [5, 10, 15],
			currentPage:1,
			perPage:  10,
			upcomingitem:[],
	        upcomingfields:[
	        {key: 'deliveryagentname', label: 'Rider Name'},
	        {key: 'master_awb', label: 'Master AWB'},
		    {key: 'status', label: 'Status'},
		    {key: 'shipment_count', label: 'Shipment Count'},
		    {key: 'created_date', label: 'Upcoming Date'},
		    // {key: 'dispatch_date', label: 'Dispatch Date'},    
	        ],
	        totalRows:0,
	        shipmentModal:false,
	        shipmentawblist:[],
	        fields1:[
	          { key: 'shipmentId', label: 'Shipping Id', sortable: true, sortDirection: 'desc',tdClass: 'nameOfTheClass' },
	           { key: 'masterAwb', label: 'Master AWB', sortable: true, sortDirection: 'desc',tdClass: 'nameOfTheClass' },
	          { key: 'shipmentstatus', label: 'Shipment Status', sortable: true, sortDirection: 'desc',tdClass: 'nameOfTheClass' },
	           { key: 'deliverystatus', label: 'Delivery Status', sortable: true, sortDirection: 'desc',tdClass: 'nameOfTheClass' },
	       ],
            total_row_shipment:0,
            isBusyshipment:false,	
			shipcurrentPage:1,
			shipperPage:10,
		}
	},
	created(){
		this.upcomingMasterawbListForKsa();
	},
	methods: {
		upcomingMasterawbListForKsa(){
		  var userdata = localStorage.getItem('userData')
	      var userInfo = JSON.parse(userdata)
	      this.isBusy = true;
	      const Obj_listing = {
	    		status:'Upcoming',
	            hub_id:`${userInfo.pickuplocationmasterid}`,
	                }
	      this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getStatusWiseMasterawbListForKsa`,Obj_listing)
	            .then((result) => {
	           
           
          this.isBusy = false;
          if (result.body.returnmsg =="Successful") {
                
             this.upcomingitem = result.body.returnvalue
                  
             this.totalRows = result.body.returnvalue.length;
 
              } 
              else {
                this.upcomingitem=[];
                this.totalRows=0;  
              }
            })
            .catch((ex) => {
              console.log('error', ex)
            })
		},
		viewShipment(masterAwb){
			this.masterawbShipmentlist(masterAwb);
			
			this.shipmentModal=true;

		},
	   masterawbShipmentlist: function(masterAwb) {
      
	      console.log("Master",masterAwb);
	      var userdata = localStorage.getItem('userData')
	      var userInfo = JSON.parse(userdata)
	      this.isBusyshipment=true;
	      var Obj = {
	          
	        master_awb:masterAwb,
	      
	      };  
	       console.log("TYYY",Obj);
	  

         this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getShipmentlistOfMasterawbForKsa`,Obj)
        .then((result) => {
          console.log(result);
          this.isBusyshipment=false;
          if (result.body.returnmsg === 'Successful') {
            
          this.shipmentawblist=result.body.returnvalue;
          this.total_row_shipment=result.body.returnvalue.length;
              
          } 
          else {
          this.shipmentawblist=[];
          this.total_row_shipment=0;
          }
        })
        .catch((ex) => {
          console.log('error-----', ex)
        })   
    },
	}
	};
</script>